module.exports = {"title":"Unexpected error","action":"Please refresh Gnosus application","button":"Refresh"}